import { styled } from '@mui/material';
import { Image, Typography } from 'core/common/ui/ui-kit';

export const SolutionStyled = styled(Typography)`
  margin-bottom: 32px;
  padding-left: 12px;
  border-left: 1px solid ${({ theme }) => theme.palette.background.secondary};
`;

export const CaptionStyled = styled(Typography)`
  a {
    text-decoration: underline;
  }
`;

export const ImageStyled = styled(Image)`
  margin-right: auto;
  margin-left: auto;
`;
